
  import { Vue, Component, Prop } from 'vue-property-decorator'
  import DashboardHeader from './DashboardHeader.vue'
  import { UserModule } from '../../store/modules/user'
  @Component({
    name: 'DashboardBusiness',
    components: { DashboardHeader } 
  })
  export default class dashboardBusiness extends Vue {
    tableData: any = []
    type = 0
    title = ''
    tableHeight: number = window.innerHeight - 200
    list: any = []
    business_type:string = ''
    data_type = ''
    headerList: any = []
    list1: any = []
    list2: any = []
    list3: any = []
    instrumentTypes: any = []
    teacherType: any = []
    campusType: any = []
    time: any = [new Date(<any>new Date() - 1000 * 60 * 60 * 24 * 30),new Date()]
    start_time = ''
    end_time = ''
    loading = true
    label = '总数量'
    stxx = '试听信息'
    fstxx = '非试听信息'

    getHeight() {
      window.onresize = () =>{
        this.tableHeight = window.innerHeight - 200
      }
    }

    async getCustomerSource() {
      const res = await UserModule.customerSource()
      this.headerList = res.data.list
      this.getInstrumentType()
    }

    async getInstrumentType(){ //乐器类型
      const res = await UserModule.InstrumentType()
      this.list3 = res.data.list
      this.dataType()
    }

    async getBusinessSj() {
      const res = await UserModule.business( {business_type: this.business_type, data_type: this.data_type, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.teacherType.toString(), start_time: this.start_time, end_time: this.end_time})
      if(this.type == 2 || this.type == 7 || this.type == 8 || this.type == 9) {
        const list2 = res.data
        for(var i in list2[0]){
          if(i != 'total') {
            this.list3[0]['no_'+i] = list2[0][i]+' ('+ (list2[0][i]/list2[0]['total']*100).toFixed(2)+'%)'
          } else {
            this.list3[0]['no_'+i] = list2[0][i]
          }
        }

        if(this.list3[0]['total']+this.list3[0]['no_total'] == 0) {
          this.stxx = '试听信息 '+ this.list3[0]['total']
          this.fstxx = '非试听信息 '+ this.list3[0]['no_total']
        } else {
          this.stxx = '试听信息 '+ this.list3[0]['total'] + ' ('+ (this.list3[0]['total']/(this.list3[0]['total']+this.list3[0]['no_total'])*100).toFixed(2)+'%' +')'
          this.fstxx = '非试听信息 '+ this.list3[0]['no_total']+ ' ('+ (this.list3[0]['no_total']/(this.list3[0]['total']+this.list3[0]['no_total'])*100).toFixed(2)+'%' +')'
        }

        this.tableData = this.list3
        this.loading = false
      }
    }

    async getBusiness() {
      const res = await UserModule.business( {business_type: this.business_type, data_type: this.data_type, instrument_type: this.instrumentTypes.toString(), campus_id: this.campusType.toString(), teacher_id: this.teacherType.toString(), start_time: this.start_time, end_time: this.end_time})
      this.list1 = res.data
      if (this.type == 1){
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.tableData = this.list1
        this.loading = false

      } else if (this.type == 2) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.list3 = this.list1
        this.business_type = '2'
        this.getBusinessSj()

      } else if (this.type == 3) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.tableData = this.list1
        this.loading = false

      } else if(this.type == 4) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.tableData = this.list1
        this.loading = false

      } else if(this.type == 5) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.tableData = this.list1
        this.loading = false

      } else if (this.type == 6) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.tableData = this.list1
        this.loading = false

      } else if (this.type == 7) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.list3 = this.list1
        this.business_type = '2'
        this.getBusinessSj()

      } else if (this.type == 8) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.list3 = this.list1
        this.business_type = '2'
        this.label = '成交额'
        this.getBusinessSj()

      } else if(this.type == 9) {
        for(var i in this.list1[0]){
          if(i != 'total') {
            this.list1[0][i] = this.list1[0][i]+' ('+ (this.list1[0][i]/this.list1[0]['total']*100).toFixed(2)+'%)'
          }
        }
        this.list3 = this.list1
        this.business_type = '2'
        this.label = '均成交额'
        this.getBusinessSj()
      }
    }

    dataType() {
      this.type = Number(this.$route.query.type)
      let bus_type: any = this.$route.query.business_type
      this.business_type = bus_type ? bus_type : ''
      if (this.type == 1) {   //  客户数量 get_kehu
        this.title = '客户数量'
        const list = [{name: '总数量',prop: 'total'}]
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.data_type = '1'
        this.getBusiness()

      } else if (this.type == 2) {  //  商机数量 get_shangji
        this.title = '商机数量'
        const list = []
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.list3 = list
        for(var i = 0;i < list.length;i++) {
          this.list2.push({'name': list[i].name, 'prop': 'no_'+list[i]['prop']})
        }
        this.data_type = '2'
        this.business_type = '1'
        this.getBusiness()

      } else if (this.type == 3) {
        this.title = '试听商机数量'
        const list = [{name: '总数量',prop: 'total'}]
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list

        this.data_type = '2'
        this.business_type = '1'
        this.getBusiness()

      } else if(this.type == 4) {
        this.title = '试听商机成交量'
        const list = [{name: '成交量',prop: 'total'}]
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list

        this.data_type = '3'
        this.business_type = '1'
        this.getBusiness()

      } else if (this.type == 5) {
        this.title = '试听成交额'
        const list = [{name: '成交额',prop: 'total'}]
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.data_type = '4'
        this.business_type = '1'
        this.getBusiness()
      } else if (this.type == 6) {
        this.title = '试听均成交额'
        const list = [{name: '均成交额',prop: 'total'}]
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.data_type = '5'
        this.business_type = '1'
        this.getBusiness()
      } else if (this.type == 7) {
        this.title = '销售成交量'
        const list = []
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.list3 = list

        for(var i = 0;i < list.length;i++) {
          this.list2.push({'name': list[i].name, 'prop': 'no_'+list[i]['prop']})
        }
        this.data_type = '3'
        this.business_type = '1'
        this.getBusiness()
      } else if (this.type == 8) {
        this.title = '销售成交额'
        const list = []
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.list3 = list
        this.list2 = []
        for(var i = 0;i < list.length;i++) {
          this.list2.push({'name': list[i].name, 'prop': 'no_'+list[i]['prop']})
        }
        this.data_type = '4'
        this.business_type = '1'
        this.getBusiness()
      } else if(this.type == 9) {
        this.title = '销售均成交额'
        const list = []
        for(var i = 0; i < this.headerList.length; i++) {
          list.push({name: this.headerList[i].name, prop: 'source'+this.headerList[i].id})
        }
        for(var i = 0; i < this.list3.length; i++) {
          list.push({name: this.list3[i].name,prop: 'instrument_type_id'+this.list3[i].id})
        }
        const list4 = [{name: '成人', prop: 'ages1'},{name: '儿童', prop: 'ages2'},{name: '学生', prop: 'ages3'}]
        for(var j = 0; j < list4.length;j++) {
          list.push(list4[j])
        }
        this.list = list
        this.list3 = list

        for(var i = 0;i < list.length;i++) {
          this.list2.push({'name': list[i].name, 'prop': 'no_'+list[i]['prop']})
        }
        this.data_type = '5'
        this.business_type = '1'
        this.getBusiness()
      }
    }

    getDataChange(val:any){
      this.instrumentTypes = val.instrumentTypes
      this.teacherType = val.teacherType
      this.campusType = val.campusType
      this.time = val.time
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
      this.getCustomerSource()
    }

    //  跳转至客户列表
    toCustomer(val) {
      let type = ''
      let key: string = ''
      let value: string = ''
      if(val.prop.includes('source')) {
        key = 'source'
        value = val.prop.replace('source','')
      } else if (val.prop.includes('ages')) {
        key = 'ages'
        value = val.prop.replace('ages','')
      } else if (val.prop.includes('instrument_type_id')) {
        key = 'instrument_type_id'
        value = val.prop.replace('instrument_type_id','')
      } else {
        key = ''
        value = ''
      }
      if(this.type === 1) {
        type = '/customer/list'
      } else if(this.type === 2 || this.type === 3) {
        type = '/customer/business'
      } else if (this.type === 4) {
        type = '/order/index'
      }
      if(type) {
        this.$router.push({ path: `${type}`, query: { from: 'business', key: key, value: value, campus: JSON.stringify(this.campusType),time: JSON.stringify(this.time),teacher: JSON.stringify(this.teacherType), instrument: JSON.stringify(this.instrumentTypes) } })
      }
    }

    mounted(){
      this.start_time = (Date.parse(<any>this.time[0])/1000).toString()
      this.end_time = (Date.parse(<any>this.time[1])/1000).toString()
      this.getHeight()
      this.getCustomerSource()

    }
  }
